const ITEMS = [
  "REVOL STUDIOS",
  "STEP BEYOND THE SCREEN",
  "360° VIRTUAL TOURS",
  "AVATAR CREATION",
  "REVOL ENGINE",
  "MULTILINGUAL DUBBING",
  "INTERACTIVE VIDEO",
];

export const EditorialMarquee = () => {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div className="relative z-10 overflow-hidden border-t border-white/5 py-5" data-testid="editorial-marquee">
      <div className="marquee-track flex w-max items-center gap-10 whitespace-nowrap">
        {[...row, ...row].map((item, i) => (
          <span key={i} className="flex items-center gap-10">
            <span className="font-mono-brand text-xs uppercase tracking-[0.35em] text-[#a1a1aa]/60">{item}</span>
            <span className="h-1 w-1 rounded-full bg-[#ed4609]/60" />
          </span>
        ))}
      </div>
    </div>
  );
};
